// extracted by mini-css-extract-plugin
export default {"root":"Button_root__TXd9J","btn":"Button_btn__IyDNN","badge":"Button_badge__K1Ubj","reset":"Button_reset__DQUZ0"};